import React, {createContext, useReducer } from 'react';

const Reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'INITIALIZECONFIG': 
            return {
                ...state,
                baseUrl: action.payload.baseUrl,
                version: action.payload.version,
                applicationUrl: action.payload.applicationUrl,
                skillPointTypeNames: action.payload.skillPointTypeNames,
                statTypeNames: action.payload.statTypeNames,
                slUrl: action.payload.slUrl,
                ownUrl: action.payload.ownUrl,
                appName: action.payload.appName
            }
        case 'LOGIN':
            checkSl(action.payload, state.storyName)
            return {
                ...state,
                user: action.payload,
            }
        case 'SETLOGINREDIRECT':
            return {
                ...state,
                loginRedirect: action.payload,
            }
        case 'LOGOUT':
            return {
                ...state,
                isSlOfStory: false,
                user: undefined,
            }
        case 'SETSTORYID': 
        checkSl(state.user, action.payload.storyName)
        return {
            ...state,
            storyId: action.payload.storyId,
            storyName: action.payload.storyName,
        }
        case 'SETSELECTEDPAGE': 
        return {
            ...state,
            selectedPage: action.payload,
        }
        case 'SETSKILLPOINTTYPES': 
        return {
            ...state,
            skillPointTypes: action.payload,
        }
        case 'SETSTATTYPES': 
        return {
            ...state,
            statTypes: action.payload,
        }
        case 'SETCONFIGURATIONS': 
        return {
            ...state,
            configurations: action.payload,
        }
        case 'SETSTORIES': 
        return {
            ...state,
            stories: action.payload,
        }
        
        default:
            return state;
    }

    function checkSl(user, storyName) {
        state.isSlOfStory = user.userRoles.filter(userRole => userRole.includes(`SL|${storyName}`)).length >= 1
        state.isAnSl = user.userRoles.filter(userRole => userRole.includes(`SL|`)).length >= 1 
        state.isAgnoiaSl = user.userRoles.filter(userRole => userRole.includes(`SL|Agnoia`)).length >= 1 
        state.isZomerlarpSl = user.userRoles.filter(userRole => userRole.includes(`SL|Zomerlarp`)).length >= 1 
        state.isStormvloedSl = user.userRoles.filter(userRole => userRole.includes(`SL|Stormvloed`)).length >= 1 
    }

    // function getBoolFromString(stringValue) {
    //     return JSON.parse(stringValue);
    // }
}

const initialState = {
    baseUrl: "unknown",
    version: "unknown",
    applicationUrl: "",
    user: undefined,
    storyId : localStorage.getItem('LarpTOM.StoryId') ?? -1,
    storyName : localStorage.getItem('LarpTOM.StoryName'),
    isSlOfStory : false,
    isAnSl: false,
    isStormvloedSl: false,
    isAgnoiaSl: false,
    isZomerlarpSl: false,
    selectedPage : "Home",
    skillPointTypes : [],
    statTypes: [],
    configurations: [],
    skillPointTypeNames: {},
    statTypeNames: {},
    loginRedirect: "/portal/",
    stories: [],
    slUrl: '',
    ownUrl: '',
    appName: ''
}

const AppContext = ({ children }) => {
    const [state, dispatch] = useReducer(Reducer, initialState);

    return (
        <appContext.Provider value={[state, dispatch]}>
            {children}
        </appContext.Provider>
    )
};


export const appContext = createContext(initialState);
export default AppContext;